<template>
    <ReasonCode></ReasonCode>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ReasonCode = defineAsyncComponent(() =>
    import("../../components/Management/ReasonCode/ReasonCode.vue")
);

export default {
    components: { ReasonCode, AuthLayout },
};
</script>
